import $ from 'jquery';
import PL_utils from '../patterns/pl-utils.js';

function ss() {
    $(window).on('load', function () {
        const url = window.location.href;
        const ww = $(window).width();
        const isEDMode = url.indexOf('ed=1') > -1;

        // ED mode
        if (isEDMode) {
            const body = document.querySelector('body');
            PL_utils.addClass('edmode', body);
        }

        //sticky isi
        if (url.indexOf('isi=1') > -1) {
            document.getElementById('sticky-isi').style.display = 'block';
            PL_utils.addClass('fixed-screenshot', document.getElementById('sticky-isi'));
        }

        //mobile navigation
        if (url.indexOf('mobile-nav=1') > -1) {
            document.getElementById('navigation-trigger').click();
        }

        //mobile navigation with all subnavs open
        if (url.indexOf('mobile-nav=2') > -1) {
            document.getElementById('navigation-trigger').click();
            document.querySelector('.nav__link.opioid-addiction').click();
            document.querySelector('.nav__link.about-sublocade').click();
            document.querySelector('.nav__link.prep-for-treatment-journey').click();
            document.querySelector('.nav__link.resources').click();
        }

        //accordions
        if (url.indexOf('accordions=1') > -1) {
            accordion.expandAll();
        }


        const printError = ($ele, error) => {
            $ele.append(error);
        };

        const constructError = (errorMsg) => {
            return `<p class="form-error flex-vertical-center">
        <svg class="svg--icon-warning">
          <use xlink:href="#icon-warning"></use>
        </svg>
        <span>${errorMsg}</span>
        <i class="tool-tip-visual"></i>
      </p>`;
        };

        const updateErrorStyle = () => {
            const fieldlist = document.getElementsByTagName('input');
            for (let field of fieldlist) {

                if (field.getAttribute("class") != "optional") {
                    PL_utils.addClass('error', field);
                }
            }
        }

        const printErrors = () => {
            document.querySelectorAll('.form-error').forEach(error => {
                PL_utils.removeClass('hidden', error);
            })

            updateErrorStyle();
        };



        // header fatp error
        if (url.indexOf('home-fatp-error=1') > -1) {
            if (ww < 768) {
                $('.header__zip-search-trigger').click();
            }
            document.querySelector('.FATP-search-btn.btn-cta').click();
            document.querySelector('#FATP-search-header-input').blur();
        }



        //subscribe error
        if (url.indexOf('/sign-up') > -1 && url.indexOf('error=1') > -1) {
            printErrors();
        }

        //unsubscribe error
        if (url.indexOf('/unsubscribe') > -1 && url.indexOf('error=1') > -1) {
            printErrors();
        }


        // removes focus from Find treatment error form field
        if (url.indexOf('error=1') > -1 && url.indexOf('clickSubmit') > -1) {
            document.querySelector('.btn-primary.FATP-search-btn').click();
            setTimeout(function () {
                document.activeElement.blur();
            }, 1000);
        }

        //Email me modal error
        if (url.indexOf('modal=email') > -1) {
            document.querySelector('section[data-modal="emailme"]').classList.remove('scrollable');
        }

        if (url.indexOf('modal=email') > -1 && url.indexOf('error=1') > -1) {
            setTimeout(function () {
                document.querySelector('#send-results').click();
                document.activeElement.blur();
            }, 1000)
        }

        if (url.indexOf('modal=') > -1) {
            $('.modal__close').css("outline", "none");
        }




        // Trigger FOCUS states for all 
        if (window.location.href.indexOf('focus=all') > -1) {
            document.querySelectorAll('a, #ot-sdk-btn').forEach((item) => {
                PL_utils.addClass('focus', item);
            });

            //skip content header
            PL_utils.addClass('active', document.querySelectorAll('.skip-link')[0]);
            PL_utils.addClass('focus', document.querySelectorAll('.FATP-search-input')[0]);
            PL_utils.addClass('focus', document.querySelectorAll('.FATP-search-input')[1]);
        }

        // Trigger FOCUS states for FATP 
        if (url.indexOf('treating-your-disease') > -1 && url.indexOf('focus=fatp') > -1) {
            PL_utils.addClass('focus', document.querySelectorAll('.fatp-section')[0]);
        }

        // Trigger HOVER STATES
        if (window.location.href.indexOf('hover') > -1) {
            if (url.indexOf('/results') > -1) {
                PL_utils.addClass('hover', document.querySelectorAll('.result-item')[0]);
            } else {
                document.querySelectorAll('a, #ot-sdk-btn').forEach((item) => {
                    PL_utils.addClass('hover', item);
                });
                document.querySelectorAll('.section-grassland--right').forEach((item) => {
                    PL_utils.addClass('hover', item);
                });

                PL_utils.addClass('hover', document.querySelectorAll('.nav__item')[0]);
                PL_utils.removeClass('hover', document.querySelectorAll('.nav__item .subnav__link')[1]);

            }
        }

        if (window.location.href.indexOf('expand=0') > -1) {
            PL_utils.addClass('hover', document.querySelectorAll('.nav__item')[0]);
        }
        if (window.location.href.indexOf('expand=1') > -1) {
            PL_utils.addClass('hover', document.querySelectorAll('.nav__item')[1]);
        }
        if (window.location.href.indexOf('expand=2') > -1) {
            PL_utils.addClass('hover', document.querySelectorAll('.nav__item')[2]);
        }
        if (window.location.href.indexOf('expand=3') > -1) {
            PL_utils.addClass('hover', document.querySelectorAll('.nav__item')[4]);
        }

        //expand isi
        if (window.location.href.indexOf('expand-isi=1') > -1) {
            document.getElementById('sticky-isi').style.display = 'none';
        }

        if (window.location.href.indexOf('removeBorder') > -1) {
            setTimeout(() => {
                document.activeElement.blur();
                document.activeElement;
            }, 3000);
        }

        if (window.location.href.indexOf('clickPin') > -1) {
            setTimeout(() => {
                document.querySelectorAll('div[role="button"]')[9].click();
                document.activeElement.blur();
            }, 10000)
        }

        //Cookies banner
        if (window.location.href.indexOf('cookieBanner') > -1) {
            setTimeout(() => {
                document.querySelector('html').style.overflow = 'visible';
                document.activeElement.blur();
            }, 5000);
            document.querySelector('body').classList.add('cookies');
        }
        if (window.location.href.indexOf('cookieBannerHover') > -1) {
            document.querySelector('body').classList.add('cookies-hover');
        }
        if (window.location.href.indexOf('cookieBannerFocus') > -1) {
            document.querySelector('body').classList.add('cookies-focus');
        }
        if (window.location.href.indexOf('cookieBannerRejected') > -1) {
            setTimeout(() => {
                document.querySelectorAll('.ot-tgl input').forEach(e => {
                    e.click();
                })
            }, 5000)
        }
        if (window.location.href.indexOf('cookieBannerExpanded') > -1) {
            document.querySelector('body').classList.add('cookies-expanded');
            setTimeout(() => {
                document.querySelectorAll('button[ot-accordion="true"]').forEach(e => {
                    e.click();
                })
            }, 5000)
        }
    });
}

export default () => {
    ss();
};
